import React from "react";
import { Input } from "antd";
import "./style.scss";

const { TextArea } = Input;

export default function CustomTextArea({ label, placeholder, ...rest }) {
  return (
    <div className="custom-textarea-container mb-1">
      <div>
        <p>{label}</p>
        <TextArea placeholder={placeholder} variant="borderless" {...rest} />
      </div>
    </div>
  );
}
